<template>
	<div class="tpl no-result-wrap">
		<div class="no-content">
			<img src="../../assets/img/default/bg_img_404@2x.png"/>
			<p>页面去哪了？(⊙ˍ⊙)</p>
			<router-link tag="button" to="/">回到主页</router-link>
		</div>
	</div>
</template>

<script>
	export default{
		name:"no-result",
		created(){
			this.$store.commit("changeTabBarShow", false);
		}
	}
</script>

<style scoped>
	.no-result-wrap{
		padding-top: 5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/404.vue